import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import '../Bill_Information.css';
import daikin_logo from '../../../../Images/Daikin_Images/Daikin-logo.png';
import { getMonthName, isEmpty } from '../../../Common/Common';
import Bill_Page from './Components/Bill_Page';
import Power_Consumption from './Components/Power_Consumption';

export default class Bill_Information extends Component {
	constructor(props) {
		super(props);
		this.price_info = this.props.param.price_info;
		this.selected_tenant = this.props.param.tenant_name;
		this.bill_data = this.props.param.bill_data;

		// Set Default for price info in case data is empty
		if (isEmpty(this.price_info)) {
			this.price_info = {};
		}

		if (isEmpty(this.price_info.zone)) {
			this.price_info.zone = {};
		}

		if (isEmpty(this.price_info.zone.weekday)) {
			this.price_info.zone.weekday = {};
		}

		if (isEmpty(this.price_info.zone.holiday)) {
			this.price_info.zone.holiday = {};
		}
	}

	handlePrevious = () => {
		window.app.showLoading();
		this.props.receiver.loadTenant();
	}

	//Convert table information to csv
	handleLeftButtonAction = () => {
		let fy = this.props.param.from_date.getFullYear();
		let fm = getMonthName(this.props.param.from_date.getMonth());
		let fd = this.props.param.from_date.getDate();
		let ty = this.props.param.to_date.getFullYear();
		let tm = getMonthName(this.props.param.to_date.getMonth());
		let td = this.props.param.to_date.getDate();

		for (let x = 0; x < this.selected_tenant.length; x++) {
			let file_name = this.selected_tenant[x] + " " + fd + " " + fm + " " + fy + "-" + td + " " + tm + " " + ty + ".csv";
			let csv = [];

			//Tenant's name [Tenant]
			csv.push(this.selected_tenant[x]);

			// Bill Period [Period, 1-Mar-2021,To, 1-Mar-2021]
			var period_arr = [this.props.receiver.getString("period"), fd + "-" + fm + "-" + fy, this.props.receiver.getString("to"), td + "-" + tm + "-" + ty];
			csv.push(period_arr.join(","));

			// Total Amount [Currency, S$, 0]
			var total_amount_arr = [this.props.receiver.getString("ppd_total"), this.price_info.currency, this.total_data_info[this.selected_tenant[x]].total_price];
			csv.push(total_amount_arr.join(","));
			csv.push(",");

			// Table
			var tables = document.querySelectorAll("table");
			var rows = tables[x * 2].querySelectorAll("tr"); //first table
			for (var i = 0; i < rows.length; i++) { //loop all the rows in the first table
				var row = [], cols = rows[i].querySelectorAll("td, th"); //loop all the columns in each row
				for (var j = 0; j < cols.length; j++)
					row.push(cols[j].innerText);
				csv.push(row.join(","));
			}

			csv.push(",");
			csv.push(this.props.receiver.getString("power_consumption"))
			csv.push(",");

			var rows2 = tables[(x * 2) + 1].querySelectorAll("tr"); //second table of tenant
			for (var k = 0; k < rows2.length; k++) { //loop all the rows in the second table
				var row2 = [], cols2 = rows2[k].querySelectorAll("td, th"); //loop all the columns in each row
				for (var m = 0; m < cols2.length; m++)
					row2.push(cols2[m].innerText);
				csv.push(row2.join(","));
			}

			this.handleDownloadCSV(csv.join("\n"), file_name);
		}
	}

	//Download CSV
	handleDownloadCSV = (csv, file_name) => {
		var csvFile;
		var downloadLink;

		// CSV FILE
		csvFile = new Blob([csv], { type: "text/csv" });

		// Download link
		downloadLink = document.createElement("a");

		// File name
		downloadLink.download = file_name;

		// We have to create a link to the file
		downloadLink.href = window.URL.createObjectURL(csvFile);

		// Make sure that the link is not displayed
		downloadLink.style.display = "none";

		// Add the link to your DOM
		document.body.appendChild(downloadLink);

		// Lanzamos
		downloadLink.click();
	}

	//Response from controller - loading all tenants information
	rcvLoadTenant(tenant_info) {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Bill_Settings', { tenant_info: tenant_info == null ? {} : tenant_info });
	}

	handleRegister = () => {
		window.print();
	}

	render() {
		let style = {

		}

		let main_content_style = {

		}

		let bill_header_image_properties = this.props.param.bill_header_image_properties;

		let total_data_info = {}; //include information of total power consumption and total price of each tenant
		if (this.bill_data != null && this.bill_data.result == null) {
			for (let tenant in this.bill_data.bill) {
				let power_consumption = 0;
				let price = 0;
				for (let zone in this.bill_data.bill[tenant].weekday) {//for each zone in weekdays
					power_consumption += this.bill_data.bill[tenant].weekday[zone][0]; //retrieve power consumption A
					price += this.bill_data.bill[tenant].weekday[zone][3]; //retrieve price A
				}

				for (let zone in this.bill_data.bill[tenant].holiday) {//for each zone in holiday
					power_consumption += this.bill_data.bill[tenant].holiday[zone][0]; //retrieve power consumption A
					price += this.bill_data.bill[tenant].holiday[zone][3]; //retrieve price A
				}

				//power_consumption = Math.round(power_consumption * 100) / 100;
				power_consumption = power_consumption.toFixed(3);
				price = Math.round(price * 100) / 100;
				total_data_info[tenant] = {};
				total_data_info[tenant].total_power_consumption = power_consumption;
				total_data_info[tenant].total_price = price;
			}
		}
		this.total_data_info = total_data_info;

		return (
			<div id="bill_information" style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<div className="no-print">
						<Top_Bar
							width={this.props.width}
							title={this.props.receiver.getString('bill_information')}
							left_button_type={'back'}
							handleLeftButton={this.handlePrevious}
						/>
					</div>

					<div style={{ overflow: 'auto', paddingBottom: 60 }}>
						{(this.selected_tenant).map((tenant_name, index) => {
							return (
								<div>
									<Bill_Page
										header_img={bill_header_image_properties}
										tenant_name={tenant_name}
										price_info={this.price_info}
										bill_data={this.bill_data}
										total_data_info={this.total_data_info}
										receiver={this.props.receiver}
										from_date={this.props.param.from_date}
										to_date={this.props.param.to_date}
										owner_info={this.props.param.owner_info}
										width={this.props.width}
									/>

									{/* White space - Changing of height might affect the page break*/}
									<div style={{ height: 20 }}></div>

									<Power_Consumption
										tenant_name={tenant_name}
										from_date={this.props.param.from_date}
										to_date={this.props.param.to_date}
										receiver={this.props.receiver}
										price_info={this.price_info}
										bill_data={this.bill_data}
										owner_info={this.props.param.owner_info}
										tenant_info={this.props.param.tenant_info}
									/>

								</div>
							)
						})}
					</div>

				</div>
			</div >
		)
	}
}